import { useState, useEffect, useRef } from "react";
import queryString from "query-string";

import Analytics from "analytics/util/Analytics";
import loadjs from "shared/util/loadjs";
import isApp from "shared/util/isApp";
import { isDev, isIOS } from "shared/util/EnvironmentHelpers";

const MPARTICLE_API_KEY = "a8c837bced3bf546b6bfcad20f81ccb0";
const MPARTICLE_SDK_URL = `https://jssdkcdns.mparticle.com/js/v2/${MPARTICLE_API_KEY}/mparticle.js`;

const initializeMParticle = ({ location, userid }) => {
	const queryParams = queryString.parse(location.search);
	const useNativeSdk = isApp();
	const isDebug = queryParams.mparticle_debug;

	window.mParticle = {
		config: {
			useNativeSdk,
			isIOS: isIOS && isApp(),
			isDebug,
			isDevelopmentMode: isDev,
			identifyRequest: {
				userIdentities: {
					customerid: userid,
				},
			},
			dataPlan: {
				planId: "okevents",
				planVersion: 1,
			},
		},
	};
	window.mParticle.eCommerce = { Cart: {} };
	window.mParticle.Identity = {};
	window.mParticle.config = window.mParticle.config || {};
	window.mParticle.config.rq = [];
	window.mParticle.ready = (f) => {
		window.mParticle.config?.rq.push(f);
	};

	/* eslint-disable */
	function a(o, t) { return function () { t && (o = t + "." + o); var e = Array.prototype.slice.call(arguments); e.unshift(o), window.mParticle.config.rq.push(e) } } var x = ["endSession", "logError", "logEvent", "logForm", "logLink", "logPageView", "setSessionAttribute", "setAppName", "setAppVersion", "setOptOut", "setPosition", "startNewSession", "startTrackingLocation", "stopTrackingLocation"], y = ["setCurrencyCode", "logCheckout"], z = ["login", "logout", "modify"]; x.forEach(function (o) { window.mParticle[o] = a(o) }), y.forEach(function (o) { window.mParticle.eCommerce[o] = a(o, "eCommerce") }), z.forEach(function (o) { window.mParticle.Identity[o] = a(o, "Identity") });
	/* eslint-enable */

	return window.mParticle;
};

function useMParticle({ userid, guestid, location, analyticsParams }) {
	const [hasLoaded, setHasLoaded] = useState(false);
	const mParticleRef = useRef();

	if (!hasLoaded) {
		mParticleRef.current = initializeMParticle({ location, userid });
		loadjs(MPARTICLE_SDK_URL);
		setHasLoaded(true);
	}

	useEffect(() => {
		if (!mParticleRef.current) {
			return;
		}

		mParticleRef.current.ready(() => {
			if (location.pathname !== "/logout") {
				// if we're logged in, but mparticle doesn't know about our userid,
				// log in. if we have a guestid, make sure we're logged out, then set
				// it as an attribute.
				if (userid) {
					Analytics.logInIfNeeded(userid);
				} else if (guestid) {
					Analytics.logOutIfNeeded();
					Analytics.setUserProperty("guestid", guestid);
				}
			}

			// Log a pageview event
			const url = `${location.hostname}${location.pathname}${location.search}`;
			const pageviewData = { url };

			if (url.indexOf("profile") >= 0 && userid) {
				if (url.indexOf(userid) >= 0) {
					pageviewData.source = "self view";
				} else {
					pageviewData.source = "public view";
				}
			}

			mParticleRef.current.logPageView("pageview", pageviewData);
		});
	}, [mParticleRef, location, userid, guestid]);

	useEffect(() => {
		if (!mParticleRef.current) {
			return;
		}

		mParticleRef.current.ready(() => {
			if (!analyticsParams) {
				return;
			}

			Analytics.loadUserProperties(userid, analyticsParams.attributes);
		});
	}, [mParticleRef, analyticsParams, userid]);

	return mParticleRef.current;
}

export default useMParticle;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useMParticle.js